<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t(
            'school.academic.setup.program.subject.activity_subjects.activity_subject'
          )
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.setup.program.subject.activity_subjects.activity_subject'
            ),
            active: true
          }
        ]"
      />
    </div>

    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('add_new') }}
            </ts-button>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px;"
            />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.subject_name_foreign }}</td>
            <td>{{ record.subject_name_native }}</td>
            <td>{{ record.subject_code }}</td>
            <td>
              {{
                record.sub_program ? record.sub_program.acps_name_foreign : ''
              }}
            </td>
            <td>{{ record.program ? record.program.acp_name_foreign : '' }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData">
          </ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'subject-activity',
  components: { FormComponent },
  props: ['programs', 'subPrograms'],
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('subjectActivity', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.subjectActivity.search
      },
      set(newValue) {
        this.$store.commit('subjectActivity/SET_SEARCH', newValue)
        this.$store.commit('subjectActivity/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.subject_(en)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.subject_(kh)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.subject_code'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.sub_program'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.main_program'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.activity_subjects.actions'
          ),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('subjectActivity/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('subjectActivity/destroy', record.subject_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          programs: this.programs,
          subPrograms: this.subPrograms,
          editData: editData
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'subject-activity-create') {
      this.$store.commit('subjectActivity/RESET_STATE')
    }
    next()
  }
}
</script>
